import PdfViewer from 'components/shared/PdfViewer';
import { FunctionComponent, useEffect } from 'react';

const AntiSlaveryStatement: FunctionComponent = () => {
  useEffect(() => {
    document.dispatchEvent(new Event('page-fetched'));
  }, []);

  return <PdfViewer url="/docs/SEENGROUP-Anti-Slavery-June 2026.pdf" />;
};

export default AntiSlaveryStatement;
